import { render, staticRenderFns } from "./TonalCommentBody.vue?vue&type=template&id=218056e6&"
import script from "./TonalCommentBody.vue?vue&type=script&lang=js&"
export * from "./TonalCommentBody.vue?vue&type=script&lang=js&"
import style0 from "./TonalCommentBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports